import React from 'react'
import HomePage from '../pages/customer_portal/HomePage'
import CreateJobPage from '../pages/customer_portal/CreateJobPage';
import UpdateJobPage from '../pages/customer_portal/UpdateJobPage';
import JobDetailPage from '../pages/customer_portal/JobDetailPage';
import { Routes, Route, Navigate } from "react-router-dom";

const CustomerPortalRoutes = () => {
  return (
    <Routes>
      <Route exact path="/" element={<HomePage />} />
      <Route exact path="/create-job" element={<CreateJobPage />} />
      <Route exact path="/update-job/:jobId" element={<UpdateJobPage />} />
      <Route exact path="/job-detail/:jobId" element={<JobDetailPage />} />
      <Route path="*" element={<Navigate replace to="/" />} />
    </Routes>
  )
}

export default CustomerPortalRoutes
